import { useEffect, useState } from "react";
import { Minus, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { brl, imgUrl } from "@/lib/api";
import { limitText, summarize, togglePick } from "@/lib/options";
import { cn } from "@/lib/utils";

export function OptionsDialog({ product: p, onClose, onAdd }) {
  const [sel, setSel] = useState({});
  const [qty, setQty] = useState(1);
  const [notes, setNotes] = useState("");
  useEffect(() => { setSel({}); setQty(1); setNotes(""); }, [p]);
  if (!p) return null;
  const { options, extra, missing, missingText, label } = summarize(p, sel);
  const add = () => { onAdd({ product: p, options, qty, notes, name: p.name + label, price: p.price + extra }); onClose(); };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="pos-options-modal">
        <DialogHeader><DialogTitle>{p.name}</DialogTitle></DialogHeader>
        {p.image_url && <img src={imgUrl(p.image_url)} alt={p.name} className="h-32 w-full rounded-lg object-cover" />}
        {(p.option_groups || []).map((g) => (
          <div key={g.name} className="space-y-2" data-testid={`options-group-${g.name}`}>
            <p className="text-sm font-semibold">{g.name} <span className="text-xs font-normal text-muted-foreground">{limitText(g)} · {(sel[g.name] || []).length} selecionado(s)</span></p>
            <div className="grid grid-cols-2 gap-2">
              {g.options.map((o) => {
                const on = (sel[g.name] || []).includes(o.name);
                return (
                  <button key={o.name} onClick={() => setSel((s) => togglePick(s, g, o.name))} data-testid={`pos-option-${g.name}-${o.name}`}
                    className={cn("flex justify-between rounded-lg border px-3 py-2 text-sm transition-colors", on ? "border-primary bg-primary/10 font-semibold" : "hover:bg-accent")}>
                    <span>{o.name}</span><span className="font-mono text-xs">{Number(o.price) > 0 ? `+${brl(o.price)}` : ""}</span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
        <Input value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Observação (ex.: sem cebola)" data-testid="pos-options-notes" />
        <div className="flex items-center gap-3">
          <Button size="icon" variant="outline" onClick={() => setQty((q) => Math.max(1, q - 1))}><Minus className="h-4 w-4" /></Button>
          <span className="w-6 text-center font-mono">{qty}</span>
          <Button size="icon" variant="outline" onClick={() => setQty((q) => q + 1)} data-testid="pos-options-qty-inc"><Plus className="h-4 w-4" /></Button>
          <Button className="flex-1 h-11" disabled={!!missing} onClick={add} data-testid="pos-options-add-btn">
            {missing ? missingText : `Adicionar ${brl((p.price + extra) * qty)}`}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
